<template>
  <section>
    <country-template-list :query="query" />
  </section>
</template>

<script>
import CountryTemplateList from '@/components/mis/CountryTemplateList'

export default {
  name: 'CountryTemplates',
  components: {
    CountryTemplateList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
